import { Component, OnInit, Inject, ChangeDetectorRef, ViewChild } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA, MatTableDataSource, MatPaginator, MatSort, MatPaginatorIntl, Sort } from '@angular/material';
import { GoogleAnalyticsService } from '../../services/google_analytics/google-analytics.service';
import { UploadService } from '../../services/upload/upload.service';
import * as momenttimezone from 'moment-timezone';
import { ParComplaintsDocumentsService } from '../../services/par-complaints-documents/par-complaints-documents.service';
import { documentInformationList } from '../../model/document.model';
import { environment } from '../../../environments/environment';
declare let ga: any;
@Component({
  selector: 'app-par-complaints-documents',
  templateUrl: './par-complaints-documents.component.html',
  styleUrls: ['./par-complaints-documents.component.css']
})

export class ParComplaintsDocumentsComponent implements OnInit {
  matSpinner: boolean = false;
  fileName: string[] = [];
  documentlink : string[] = [];
  loginId: any;
  documentInfo: documentInformationList = new documentInformationList();
  newFilePath1;
  signedUrl;
  message;
  uploadFlag : boolean = true;
  AddDocErr: boolean;
  AddDocErrMsg: string;
  firstName;
  lastName;

  constructor(public dialogRef: MatDialogRef<ParComplaintsDocumentsComponent>,
              private googleAnalyticsService: GoogleAnalyticsService,
              @Inject(MAT_DIALOG_DATA) public complaintsData: any,
              private uploadService: UploadService,
              public ref: ChangeDetectorRef,
              public ParComplaintsDocumentsService : ParComplaintsDocumentsService) {
  }

  ngOnInit() {
    this.loginId = localStorage.getItem('loginID');
    this.firstName =  localStorage.getItem("username");
    this.lastName = localStorage.getItem('Lastname');
  }

  onNoClick() {
    this.dialogRef.close();
  }

  setFileData(docInfo) {
    //this.googleAnalyticsService.emitEvent(this.firstName + ' ' + this.lastName, "Create a" + ' ' + this.agentdata.data.DocumentTypeName + ' ' + 'Document', this.vendorName, 10);
    setTimeout(() => {
      this.documentInfo = docInfo;
      this.fileName = this.documentInfo.fileName;
      this.ref.markForCheck();
      this.ref.detectChanges()
    }, 100);
  }

  scrollTop() {
    const element = document.getElementById('scrollToTop');
    element.scrollIntoView();
  }

  saveDocument() {
    this.matSpinner = true;
    this.uploadFlag = false;
    this.fileName = [];
    this.documentlink = [];
    let today = new Date();
    const estTimeZone = 'America/New_York';
    let uploadTimeZone = momenttimezone(today).tz(estTimeZone).format();
    uploadTimeZone = uploadTimeZone.replace(/[^a-zA-Z0-9]/g, '');

    let filePath = "Complaints/" + this.complaintsData.ComplaintId + "/Documents/";
    for (var i=0; i < this.documentInfo.file.length; i++) {
      this.fileName.push(this.documentInfo.fileName[i]);
      let fileNameWithoutExt = this.documentInfo.fileName[i].substring(0, this.documentInfo.fileName[i].lastIndexOf('.'));
      let fileNameExt = this.documentInfo.fileName[i].substring(this.documentInfo.fileName[i].lastIndexOf('.') + 1,
                                                                this.documentInfo.fileName[i].length);
      this.documentInfo.fileInput[i].append('url', filePath + fileNameWithoutExt + '_' + uploadTimeZone + '.' + fileNameExt);
      let newFilePath1 = filePath + fileNameWithoutExt + '_' + uploadTimeZone + '.' + fileNameExt;
      let body = {
        "newFilePath": newFilePath1
      };
      this.documentlink.push(newFilePath1);
      let file = this.documentInfo.file[i];
      this.uploadService.getSignedURL(body).subscribe((res) => {
        this.signedUrl = res.Info;
        this.uploadService.uploadDocumentWithSignedUrl(file, this.signedUrl).subscribe((obj) => {
          //this.submit();
        });
      }, error => {
        this.AddDocErr = true;
        this.AddDocErrMsg = 'Internal Server Error. Please try Again' + error;
        this.scrollTop();
        this.matSpinner = false;
      });
    }
    this.submit();
  }

  submit() {
    this.AddDocErr = false;
    let request = {
      complaint_id: this.complaintsData.ComplaintId,
      document_link: this.documentlink,
      document_name: this.fileName,
      document_type: "",
      uploaded_by: this.loginId
    };
    this.ParComplaintsDocumentsService.addDocument(request).subscribe(res => {
      setTimeout(() => {
        ga('CompliantsTracker.send', 'event',this.firstName + ' ' + this.lastName,environment.googleAnalyticsEvents[7],this.loginId, 1);
        //this.googleAnalyticsService.emitEvent(this.firstName + ' ' + this.lastName, "Create a" + ' ' + this.agentdata.data.DocumentTypeName + ' ' + 'Document', this.vendorName, 10);
        this.message = 'Document Added Successfully';
        this.ParComplaintsDocumentsService.load.next('success');
        this.dialogRef.close();
      }, 3000);
    }, err => {
      this.message = err;
      this.AddDocErr = true;
      this.AddDocErrMsg = 'Internal Server Error. Please try Again';
      this.matSpinner = false;
      this.scrollTop();
      this.ParComplaintsDocumentsService.load.next('fail')
    })
  }
}



// WEBPACK FOOTER //
// ./src/app/components/par-complaints-documents/par-complaints-documents.component.ts